import SignupLayout from "./SignupLayout.tsx";
import { createSignal, Show } from "solid-js";
import SignupForm from "./SignupForm.tsx";
import VerifyEmail from "./VerifyEmail.tsx";
import type { SignupRequest } from "../../services/SignupService.ts";

const SignupPage = () => {
  const [signupRequest, setSignupRequest] = createSignal<SignupRequest>();

  return (
    <SignupLayout>
      <Show fallback={<SignupForm onSignup={setSignupRequest} />} when={signupRequest()}>
        {(signupRequest) => <VerifyEmail signupRequest={signupRequest()} />}
      </Show>
    </SignupLayout>
  );
};

export default SignupPage;
